/* eslint-disable */

import axios from 'axios'
import store from './store'
import router from './router'
import api from "./mixins/api";

let isRefreshing = false; // 是否正在 refresh token
let hasAlertedExpired = false; // 避免多隻無權限 401 api 同時 alert
let pendingRequests = []; // refresh 期間等待的請求隊列


function handlePermissionDenied(alertMsg) {
  alert(alertMsg);
  localStorage.clear();
  router.push("/login");
}

// 顯示全域 loading
axios.interceptors.request.use(
  config => {
    store.state.isLoading = true
    axios.defaults.headers.common['Accept-Language'] = localStorage.getItem('lang') || 'en';
    return config
  },
  err => {
    return Promise.reject(err)
  }
);

// 無網路時取消請求
axios.interceptors.request.use(
  (request) => {
    if (!window.navigator.onLine) {
      // 取消請求
      return Promise.reject(new Error('No network connection'));
    }
    return request;
  },
  (err) => {
    store.commit('updateShowLoading', false);
    return Promise.reject(err);
  },
);

axios.interceptors.response.use(
  response => {
    store.state.isLoading = false;
    hasAlertedExpired = false;
    return response;
  },
  async error => {
    store.state.isLoading = false;

    if (['Calculator'].includes(router.currentRoute.name)) {
      return "these pages are ok";
    }

    const originalRequest = error.config;

    // 收到 401 時嘗試 refresh token，由 Microsoft server 判斷 token 是否過期
    if (error.response && error.response.status === 401) {
      // 避免 refresh API 自己進來造成無限循環
      if (originalRequest.url.includes("/oauth2/v2.0/token")) {
        localStorage.clear();
        router.push("/login");
        return Promise.reject(error.response);
      }

      // 同一支 request 最多 retry 一次,如 a api 一直在 401,就不會無限 retry
      if (originalRequest._retry) {
        if (!hasAlertedExpired) {
          hasAlertedExpired = true;
          handlePermissionDenied("Your don't have permission.");
        }
        return Promise.reject(error.response);
      }

      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const refreshToken = localStorage.getItem("refresh_token");
          if (!refreshToken) throw new Error("No refresh token");

          const res = await api.methods.refreshAccessToken.call(
            { $axios: axios },
            refreshToken
          );
          const { access_token, refresh_token } = res.data;
          localStorage.setItem("access_token", `Bearer ${access_token}`);
          localStorage.setItem("refresh_token", refresh_token);

           // headers 可能不存在，防呆
          originalRequest.headers = originalRequest.headers || {};
          // 更新觸發 refresh 的那個請求的 header，帶新 token 重打
          originalRequest.headers["Authorization"] = `Bearer ${access_token}`;

          // 通知隊列中等待的請求，帶新 token 重打
          pendingRequests.forEach((cb) => cb(access_token));
          pendingRequests = [];

          // 重打觸發 refresh 的那個請求
          return axios(originalRequest);

        } catch (e) {
          // refresh 失敗，清空隊列並登出
          pendingRequests.forEach((cb) => cb(null, e));
          pendingRequests = [];
          if (!hasAlertedExpired) {
            hasAlertedExpired = true;
            handlePermissionDenied("You have been logged out because your session has expired.");
          }
          return Promise.reject(e);

        } finally {
          isRefreshing = false;
        }
      } else {
        // 正在 refresh 中，將請求加入隊列，等 refresh 完成後重打
        return new Promise((resolve, reject) => {
          pendingRequests.push((newToken, err) => {
            if (err) return reject(err);
            originalRequest.headers = originalRequest.headers || {};
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            resolve(axios(originalRequest));
          });
        });
      }
    }

    console.warn("Api error msg:", error.response && error.response.data);
    if (error && error.response) {
      return Promise.reject(error.response); //HTTP錯誤
    } else {
      return Promise.reject(error); //timeout
    }
  }
);

export default axios;